import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PropensityPredictionsResponse, PropensityPredictionItem } from '@/services/api';

export interface PropensityState {
  items: PropensityPredictionItem[];
  total: number;
  limit: number;
  offset: number;
  isLoading: boolean;
  error: string | null;
  search: string;
}

const initialState: PropensityState = {
  items: [],
  total: 0,
  limit: 20,
  offset: 0,
  isLoading: false,
  error: null,
  search: ''
};

export const FETCH_PROPENSITY_PREDICTIONS_REQUESTED = 'propensity/FETCH_PREDICTIONS_REQUESTED';
export const FETCH_PROPENSITY_PREDICTIONS_SUCCEEDED = 'propensity/FETCH_PREDICTIONS_SUCCEEDED';
export const FETCH_PROPENSITY_PREDICTIONS_FAILED = 'propensity/FETCH_PREDICTIONS_FAILED';

export const fetchPredictionsRequested = (payload?: { limit?: number; offset?: number; search?: string }) => ({
  type: FETCH_PROPENSITY_PREDICTIONS_REQUESTED,
  payload
});

export const fetchPredictionsSucceeded = (payload: PropensityPredictionsResponse) => ({
  type: FETCH_PROPENSITY_PREDICTIONS_SUCCEEDED,
  payload
});

export const fetchPredictionsFailed = (payload: string) => ({
  type: FETCH_PROPENSITY_PREDICTIONS_FAILED,
  payload
});

const propensitySlice = createSlice({
  name: 'propensity',
  initialState,
  reducers: {
    setPropensityLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setPropensityError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setPropensityPagination(state, action: PayloadAction<{ limit?: number; offset?: number }>) {
      if (typeof action.payload.limit === 'number') state.limit = action.payload.limit;
      if (typeof action.payload.offset === 'number') state.offset = action.payload.offset;
    },
    setPropensitySearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setPropensityData(state, action: PayloadAction<PropensityPredictionsResponse>) {
      state.items = action.payload.data;
      state.total = action.payload.total;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    }
  }
});

export const { setPropensityLoading, setPropensityError, setPropensityPagination, setPropensitySearch, setPropensityData } = propensitySlice.actions;

export default propensitySlice.reducer;


